const firebase = require("../firebaseConfig.js");

const model = {
  type: "provider",
  name: {
    first: "",
    last: ""
  },
  email: null,
  verified: false,
  realPerson: false,
  experience: null,
  skills: [],
  preferences: [],
  rate: {
    min: null,
    max: null
  },
  created: null
};

const fields = [
  {
    path: "name.first",
    type: "text",
    label: "First name"
  },
  {
    path: "name.last",
    type: "text",
    label: "Last name"
  },
  {
    path: "email",
    type: "text",
    label: "Email",
    readOnly: true
  },
  {
    path: "verified",
    type: "boolean",
    label: "Verified"
  },
  {
    path: "realPerson",
    type: "boolean",
    label: "Real person"
  },
  {
    path: "experience",
    type: "number",
    label: "Years of experience"
  },
  {
    path: "skills",
    type: "multi_select",
    label: "Skills",
    reference: "skills",
    options: firebase.db.collection("skills")
  },
  {
    path: "preferences",
    type: "multi_select",
    label: "Preferences",
    reference: "preferences",
    options: firebase.db.collection("preferences")
  },
  {
    path: "goals",
    type: "multi_select",
    label: "Goals",
    reference: "goals",
    options: firebase.db.collection("goals")
  },
  {
    path: "rate.min",
    type: "number",
    label: "Minimum rate"
  },
  {
    path: "rate.max",
    type: "number",
    label: "Maximum rate"
  }
];

const tableFields = [
  {
    key: "name",
    label: "Name",
    sortable: true,
    formatter: (value, key, item) => {
      return item.name ? item.name.first + " " + item.name.last : "——";
    }
  },
  {
    key: "email",
    label: "Email",
    sortable: true
  },
  {
    key: "realPerson",
    label: "Real person",
    sortable: true
  },
  {
    key: "verified",
    label: "Verified",
    sortable: true,
    sortByFormatted: true,
    filterByFormatted: true,
    formatter: value => {
      return value ? "Yes" : "No";
    }
  }
];

const info = {
  id: "providers",
  db: "users",
  name: "Providers",
  single: "Provider",
  fields: tableFields
};

export {model, fields, info};
